// extracted by mini-css-extract-plugin
module.exports = {"ds-select":"Select_ds-select__2ZLPY","small":"Select_small__KJkJR"};